"use client";
// Imports
import { VolumeX, Volume, Play, Pause } from "lucide-react";
import { useState, useRef } from "react";
import { Container, ComponentWrapper } from "@/components";

// Video
export function Video({
  type,
  video,
  width,
  autoplay,
  youtubeVideo,
  videoType,
}) {
  const [isMuted, setIsMuted] = useState(true);
  const [isPlaying, setIsPlaying] = useState(true);
  const videoRef = useRef(null);

  // Functions
  function toggleMute() {
    const video = document.querySelector("video");
    video.muted = !video.muted;
    if (video.muted) {
      setIsMuted(true);
    } else {
      setIsMuted(false);
    }
  }

  function togglePlay() {
    if (videoRef.current.paused) {
      videoRef.current.play();
      setIsPlaying(true);
    } else {
      videoRef.current.pause();
      setIsPlaying(false);
    }
  }

  // Render
  return (
    <ComponentWrapper type={type}>
      <Container width={width}>
        {videoType == "hosted" ? (
          <div className="overflow-hidden relative p-5 w-full h-full bg-brand-wool rounded-lg">
            <video
              ref={videoRef}
              id="video"
              className="w-full"
              playsInline
              muted={autoplay ? true : false}
              loop={autoplay ? true : false}
              autoPlay={autoplay ? true : false}
              width={video?.width}
              height={video?.height}
            >
              <source src={video?.permalink} type="video/mp4" />
            </video>
            <div className="flex absolute right-8 bottom-8 z-10 justify-end space-x-5 text-white">
              <button
                className="opacity-50 lg:hover:opacity-100"
                onClick={togglePlay}
              >
                {isPlaying ? (
                  <Pause color="white" size="24" />
                ) : (
                  <Play color="white" size="24" />
                )}
              </button>
              <button
                className="opacity-50 lg:hover:opacity-100"
                onClick={toggleMute}
              >
                {isMuted ? (
                  <VolumeX color="white" size="24" />
                ) : (
                  <Volume color="white" size="24" />
                )}
              </button>
            </div>
          </div>
        ) : (
          <div className="overflow-hidden relative p-5 w-full h-full bg-brand-wool rounded-lg aspect-video">
            <iframe
              src={`https://www.youtube.com/embed/${
                youtubeVideo?.split("=")[1]
              }?autoplay=${autoplay}`}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="w-full h-full"
            ></iframe>
          </div>
        )}
      </Container>
    </ComponentWrapper>
  );
}
